import axios from 'axios';
import { ladeToken } from 'core/features/auth/authApi';

/**
 * Axios-Client für die Reddit-Buzz-API (`/api/reddit`).
 *
 * Relative baseURL: nginx leitet `/api/reddit` an den aktien-service weiter.
 * Antworten kommen im ApiResponse-Wrapper `{ success, message, data }`; die
 * Helfer geben direkt `data` zurück. Die Endpunkte sind öffentlich (kein Login
 * nötig); ein vorhandenes JWT wird der Konsistenz halber dennoch mitgesendet.
 */
const redditApi = axios.create({
  baseURL: '/api/reddit',
  timeout: 20000,
});

redditApi.interceptors.request.use((config) => {
  const token = ladeToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

const unwrap = (response) => response.data?.data;

// Aktuelles Ranking (Top-Ticker des jüngsten Snapshots).
export const fetchRedditRankingApi = () => redditApi.get('/ranking').then(unwrap);

// Zeitreihe der Erwähnungen/Upvotes eines Tickers (für den Verlauf-Chart).
export const fetchRedditHistoryApi = (ticker) =>
  redditApi.get(`/${encodeURIComponent(ticker)}/history`).then(unwrap);

// Aufschlüsselung, in welchen Subreddits ein Ticker wie oft erwähnt wird.
export const fetchRedditSubredditsApi = (ticker) =>
  redditApi.get(`/${encodeURIComponent(ticker)}/subreddits`).then(unwrap);

// Top-Beiträge je Subreddit zu einem Ticker (live aus der Reddit-JSON-Suche).
export const fetchRedditPostsApi = (ticker) =>
  redditApi.get(`/${encodeURIComponent(ticker)}/posts`).then(unwrap);

export default redditApi;
